<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>Телеграм</strong>
                </CCardHeader>
                <CForm>
                    <CCardBody>
                        <TelegramTabLinks />
                        <CRow class="pl-3 pb-3" />
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Номер группы
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="group" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Текст </CCol>
                            <CCol sm="9">
                                <CInput v-model="text" />
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="check"
                        >Проверить</CButton
                        >
                    </CCardFooter>
                </CForm>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import TelegramTabLinks from '@/components/TelegramTabLinks';

    export default {
        name: 'TelegramTest',

        components: {
            TelegramTabLinks
        },

        data() {
            return {
                group: '',
                text: '',
            };
        },

        methods: {
            validateGroup(group) {
                return group !== null && group !== '';
            },

            validateText(text) {
                return text !== null && text !== '';
            },

            check() {
                if (!this.validateGroup(this.group)) {
                    this.$root.$emit('showError', 'Введите группу.');
                    return;
                }
                if (!this.validateText(this.text)) {
                    this.$root.$emit('showError', 'Введите текст.');
                    return;
                }
                Vue.axios
                    .post('/services/telegram/test', {
                        group: this.group,
                        text: this.text,
                    })
                    .then(resp => {
                        if(resp.data.error)
                            this.$root.$emit('showError', resp.data.error);
                        else 
                            this.$root.$emit('showAlert', resp.data.message);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка при отправке тестового сообщения. ' + err);
                    });
            },

        },
    };
</script>
